export default {
  editLocation: 'Upraviť lokalitu',
  businessHours: 'Prevádzkové hodiny',
  closed: 'Zatvorené',
  loadError: 'Lokalitu sa nepodarilo načítať',
  retry: 'Skúsiť znova',
  saveError: 'Lokalitu sa nepodarilo uložiť',
  shiftsNotSaved: 'Časové pásmo bolo uložené, prevádzkové hodiny však nie',
  notMaintained: 'Nie sú zadané žiadne prevádzkové hodiny, preto sa lokalita považuje za obsadenú nepretržite.',
  shifts: 'Zmeny',
  shiftsHint: 'Názvy zmien tejto lokality. Ich časy sa nastavujú nižšie pre každý deň.',
  addShift: 'Pridať zmenu',
  newShiftDisplayName: 'Zmena {number}',
  shiftInUse: 'Najprv odstráňte okná tejto zmeny',
  invalidShiftDisplayName: 'Každá zmena potrebuje názov, ktorý nemá žiadna iná zmena tejto lokality.',
  businessHoursHint: 'Ťahaním v rámci dňa pridajte okno a ťahaním jeho úchytov zmeňte jeho časy. Vyberte okno, ak chcete zadať jeho časy alebo zmeniť jeho zmenu. Okno, ktoré končí pred svojím začiatkom, končí nasledujúci deň.',
  addShiftToDay: 'Pridať zmenu: {day}',
  noShift: 'Pridajte vyššie zmenu, aby ste mohli pridať okná.',
  allShiftsUsed: 'Každá zmena už má okno v deň: {day}.',
  overlappingWindow: 'Okná sa nesmú prekrývať, ani s oknom nasledujúceho dňa.',
  continuedFrom: '{shift} (od: {day})',
  timezoneChanged: {
    summary: 'Časové pásmo sa zmení',
    details: 'Časy tejto lokality sa budú zobrazovať v novom časovom pásme. Prevádzkové hodiny si zachovajú svoje miestne časy.',
  },
  copy: {
    workdays: 'Kopírovať na pondelok–piatok',
    allDays: 'Kopírovať na všetky dni',
  },
};
